import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  <div
  class="uploaded-image-preview input-xxlarge"
  style={{this.backgroundStyle}}
>
  {{#if this.showingPlaceholder}}
    <div class="placeholder-overlay" style={{this.placeholderStyle}}></div>
  {{/if}}
  <div class="image-upload-controls">
    <label
      class="btn btn-default pad-left no-text {{if this.disabled 'disabled'}}"
      title={{this.disabledReason}}
    >
      {{d-icon "far-image"}}
      <PickFilesButton
        @fileInputDisabled={{this.disabled}}
        @fileInputClass="hidden-upload-field"
        @acceptedFormatsOverride="image/*"
      />
    </label>

    {{#if this.imageUrl}}
      <DButton
        @action={{action "trash"}}
        @icon="far-trash-alt"
        class="btn-danger pad-left no-text"
      />
      <DButton
        @icon="discourse-expand"
        @title="expand"
        @disabled={{this.loadingLightbox}}
        @action={{unless this.experimentalLightboxEnabled this.toggleLightbox}}
        data-lightbox-trigger={{if this.experimentalLightboxEnabled "true"}}
        class="btn-default image-uploader-lightbox-btn no-text"
      />
    {{/if}}

    <span class="btn {{unless this.uploading 'hidden'}}">{{i18n
        "upload_selector.uploading"
      }}
      {{this.uploadProgress}}%</span>
    <span class="btn {{unless this.processing 'hidden'}}">{{i18n
        "upload_selector.processing"
      }}</span>
  </div>

  {{#if this.imageUrl}}
    <a
      class="lightbox"
      href={{this.imageCDNURL}}
      title={{this.imageFilename}}
      rel="nofollow ugc noopener"
    >

      <div class="meta">
        <span class="informations">
          {{this.imageWidth}}x{{this.imageHeight}}
          {{this.imageFilesize}}
        </span>
      </div>
    </a>
  {{/if}}
</div>
*/
{
  "id": "fqQdtlIf",
  "block": "[[[10,0],[14,0,\"uploaded-image-preview input-xxlarge\"],[15,5,[30,0,[\"backgroundStyle\"]]],[12],[1,\"\\n\"],[41,[30,0,[\"showingPlaceholder\"]],[[[1,\"    \"],[10,0],[14,0,\"placeholder-overlay\"],[15,5,[30,0,[\"placeholderStyle\"]]],[12],[13],[1,\"\\n\"]],[]],null],[1,\"  \"],[10,0],[14,0,\"image-upload-controls\"],[12],[1,\"\\n    \"],[10,\"label\"],[15,0,[29,[\"btn btn-default pad-left no-text \",[52,[30,0,[\"disabled\"]],\"disabled\"]]]],[15,\"title\",[30,0,[\"disabledReason\"]]],[12],[1,\"\\n      \"],[1,[28,[35,1],[\"far-image\"],null]],[1,\"\\n      \"],[8,[39,2],null,[[\"@fileInputDisabled\",\"@fileInputClass\",\"@acceptedFormatsOverride\"],[[30,0,[\"disabled\"]],\"hidden-upload-field\",\"image/*\"]],null],[1,\"\\n    \"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"imageUrl\"]],[[[1,\"      \"],[8,[39,3],[[24,0,\"btn-danger pad-left no-text\"]],[[\"@action\",\"@icon\"],[[28,[37,4],[[30,0],\"trash\"],null],\"far-trash-alt\"]],null],[1,\"\\n      \"],[8,[39,3],[[16,\"data-lightbox-trigger\",[52,[30,0,[\"experimentalLightboxEnabled\"]],\"true\"]],[24,0,\"btn-default image-uploader-lightbox-btn no-text\"]],[[\"@icon\",\"@title\",\"@disabled\",\"@action\"],[\"discourse-expand\",\"expand\",[30,0,[\"loadingLightbox\"]],[52,[51,[30,0,[\"experimentalLightboxEnabled\"]]],[30,0,[\"toggleLightbox\"]]]]],null],[1,\"\\n\"]],[]],null],[1,\"\\n    \"],[10,1],[15,0,[29,[\"btn \",[52,[51,[30,0,[\"uploading\"]]],\"hidden\"]]]],[12],[1,[28,[35,6],[\"upload_selector.uploading\"],null]],[1,\"\\n      \"],[1,[30,0,[\"uploadProgress\"]]],[1,\"%\"],[13],[1,\"\\n    \"],[10,1],[15,0,[29,[\"btn \",[52,[51,[30,0,[\"processing\"]]],\"hidden\"]]]],[12],[1,[28,[35,6],[\"upload_selector.processing\"],null]],[13],[1,\"\\n  \"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"imageUrl\"]],[[[1,\"    \"],[10,3],[14,0,\"lightbox\"],[15,6,[30,0,[\"imageCDNURL\"]]],[15,\"title\",[30,0,[\"imageFilename\"]]],[14,\"rel\",\"nofollow ugc noopener\"],[12],[1,\"\\n\\n      \"],[10,0],[14,0,\"meta\"],[12],[1,\"\\n        \"],[10,1],[14,0,\"informations\"],[12],[1,\"\\n          \"],[1,[30,0,[\"imageWidth\"]]],[1,\"x\"],[1,[30,0,[\"imageHeight\"]]],[1,\"\\n          \"],[1,[30,0,[\"imageFilesize\"]]],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],null],[13]],[],false,[\"if\",\"d-icon\",\"pick-files-button\",\"d-button\",\"action\",\"unless\",\"i18n\"]]",
  "moduleName": "discourse/components/uppy-image-uploader.hbs",
  "isStrictMode": false
});